import React from 'react';
import { Image } from 'semantic-ui-react';
import { ChildMessages_child_room_directMessages } from '../../../../../../graphql/queries/types/ChildMessages';
import ReplyComponent from './Reply';
import defaultChild from '../../../../../../assets/defaultChild.png';
import Linkify from 'react-linkify';
import { RichTextContent } from '../../../../../Client/Communication/styles';

interface Props {
  message: ChildMessages_child_room_directMessages;
}

const parseMessageContent = (body: string) => {
  try {
    // First try to parse as JSON for new rich text format
    const parsed = JSON.parse(body);
    if (parsed.type === 'rich-text') {
      return parsed.content;
    }
    return body;
  } catch {
    // If it's not JSON, check if it's raw HTML (old messages)
    if (body.startsWith('<') && body.endsWith('>')) {
      return body;
    }
    // If neither, treat as plain text
    return body;
  }
};

const renderMessageWithFile = (url: string, contentType: string, body: string) => {
  const content = parseMessageContent(body);
  const messageContent =
    content.includes('</') || content.includes('/>') ? (
      <RichTextContent dangerouslySetInnerHTML={{ __html: content }} />
    ) : (
      <p>{content}</p>
    );

  if (contentType.includes('image')) {
    return (
      <div>
        <img src={url} alt="attachment" style={{ maxWidth: '300px' }} />
        <br />
        {messageContent}
      </div>
    );
  } else if (contentType.includes('video')) {
    return (
      <div>
        <video src={url} width={320} height={240} controls />
        <br />
        {messageContent}
      </div>
    );
  } else {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        {body}
      </a>
    );
  }
};

const renderMessageContent = (message) => {
  if (message.messageFileUrl && message.messageFileContentType) {
    return renderMessageWithFile(message.messageFileUrl, message.messageFileContentType, message.body);
  }

  // Check if content contains HTML tags
  const content = parseMessageContent(message.body);
  if (content.includes('</') || content.includes('/>')) {
    return <RichTextContent dangerouslySetInnerHTML={{ __html: content }} />;
  }

  // Fallback for plain text
  return (
    <Linkify>
      <span>{message.body}</span>
    </Linkify>
  );
};

const MessageComponent = ({ message }: Props) => {
  const handleClick = (e) => {
    // Check if the message contains a link
    if (message.body.includes('http://') || message.body.includes('https://')) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const matches = message.body.match(urlRegex);
      const matchesResult = matches && matches?.length > 0 ? matches[0] : null;
      // Open the link in a new tab
      e.preventDefault();
      if (matchesResult) {
        window.open(matchesResult, '_blank');
      }
    }
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <img
          src={message.avatarUrl || defaultChild}
          alt="user avatar"
          style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '8px' }}
        />
        <div>
          <div style={{ fontWeight: 'bold' }}>{message.user.name}</div>
          <div style={{ fontSize: '12px', color: '#666' }}>{new Date(message.createdAt).toLocaleString()}</div>
        </div>
      </div>
      {renderMessageContent(message)}
      <ReplyComponent message={message} />
    </div>
  );
};

export default MessageComponent;
